module.exports = __webpack_public_path__ + "static/img/noMsg.6c2704b6.png";